import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 auto;
`;

export const Blank = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  margin: 0 24px;
  padding: 32px;
  width: 1090px;
`;
